<template>
  <!-- <pre v-if="responseData">  test data :: {{ responseData }}</pre>  -->
  <AdminBackground v-if="responseData">
    <div class="content-wrapper">
      <div class="image-wrapper">
        <img
          src="@/assets/header/PENGURUSAN PENGGUNA.png"
          alt="PENGURUSAN PENGGUNA"
          class="pbt-image"
        >

        <div class="line-under-image" />
      </div>
      <div class="pbtpay-status">
        <VRow>
          <VCol cols="12">
            <VCard>
              <VCardText class="d-flex align-center justify-space-between flex-wrap gap-4">
                <div class="d-flex gap-2 align-center">
                  <p class="text-body-1 mb-0">
                    Tunjukkan
                  </p>
                  <AppSelect
                    :model-value="itemsPerPage"
                    :items="[
                      { value: 5, title: '5' },
                      { value: 25, title: '25' },
                      { value: 50, title: '50' },
                      { value: 100, title: '100' },
                      { value: -1, title: 'All' },
                    ]"
                    style="inline-size: 5.5rem;"
                    @update:model-value="itemsPerPage = parseInt($event, 10)"
                  />
                </div>

                <div class="d-flex align-center gap-4 flex-wrap">
                  <AppTextField
                    v-model="search"
                    placeholder="Cari Pengguna"
                    style="inline-size: 15.625rem;"
                  />
                  <VBtn
                    density="default"
                    prepend-icon="tabler-plus"
                    @click="isAddUserDialogVisible = true"
                  >
                    Tambah Pengguna
                  </VBtn>
                </div>
              </VCardText>

              <VDivider />

              <VDataTableServer
                v-model:items-per-page="itemsPerPage"
                v-model:page="page"
                :items-length="totalPermissions"
                :items-per-page-options="[
                  { value: 5, title: '5' },
                  { value: 10, title: '10' },
                  { value: -1, title: '$vuetify.dataFooter.itemsPerPageAll' },
                ]"
                :headers="headers"
                :items="permissions"
                item-value="name"
                class="text-no-wrap"
                @update:options="updateOptions"
              >
                <!-- Name -->
                <template #item.name="{ item }">
                  <div class="text-high-emphasis text-body-1">
                    {{ item.name }}
                  </div>
                </template>

                <!-- Assigned To -->
                <!--
                  <template #item.assignedTo="{ item }">
                  <div class="d-flex flex-column gap-3">
                  <VChip
                  v-for="text in item.assignedTo"
                  :key="text"
                  label
                  size="small"
                  :color="colors[text].color"
                  class="font-weight-medium"
                  >
                  {{ colors[text].text }}
                  </VChip>
                  </div>
                  </template> 
                -->


                <!-- Peranan -->
                <template #item.assignedTo="{ item }">
                  <div class="d-flex flex-column gap-3">
                    <VChip
                      v-for="role in item.roles"
                      :key="role.id"
                      :color="colors[role.name.toLowerCase()]?.color || 'default'"
                      label
                      size="small"
                      class="font-weight-medium"
                    >
                      {{ role.name }}
                    </VChip>
                  </div>
                </template>


                <!-- Suspended -->
                <!--
                  <template #item.is_suspended="{ item }">
                  <div>{{ item.is_suspended ? 'Yes' : 'No' }}</div>
                  </template> 
                -->

                <template #bottom>
                  <TablePagination
                    v-model:page="page"
                    :items-per-page="itemsPerPage"
                    :total-items="totalPermissions"
                  />
                </template>

                <!-- Actions -->
                <template #item.actions="{ item }">
                  <span
                    style="color: blue; cursor: pointer;"
                    @click="showEditDialog(item)"
                  >Edit</span>
                  <span
                    style="color: red; cursor: pointer; margin-left: 10px;"
                    @click="showDeleteDialog(item)"
                  >Delete</span>
                </template>
              </VDataTableServer>
            </VCard>

   
            <VDialog
              v-model="isAddUserDialogVisible"
              max-width="500"
            >
              <VCard>
                <VCardTitle class="headline">
                  Tambah Pengguna
                </VCardTitle>
                <VCardText>
                  <div class="form-row">
                    <VTextField
                      v-model="newUser.name"
                      label="Nama"
                    />
                  </div>
                  <div class="form-row">
                    <VSelect
                      v-model="newUser.role"
                      :items="roles"
                      label="Peranan"
                      multiple
                    />
                  </div>
                  <div class="form-row">
                    <VTextField
                      v-model="newUser.email"
                      label="Emel"
                    />
                  </div>
                  <div class="form-row">
                    <VTextField
                      v-model="newUser.password"
                      label="Kata laluan"
                    />
                  </div>
                </VCardText>
                <VCardActions>
                  <VSpacer />
                  <VBtn
                    color="grey"
                    @click="isAddUserDialogVisible = false"
                  >
                    Tutup
                  </VBtn>
                  <VBtn
                    color="green"
                    @click="addUser"
                  >
                    Simpan
                  </VBtn>
                </VCardActions>
              </VCard>
            </VDialog>


            <VDialog
              v-model="isEditDialogVisible"
              max-width="500"
            >
              <VCard>
                <VCardTitle class="headline">
                  Edit Pengguna
                </VCardTitle>
                <VCardText>
                  <div class="form-row">
                    <VTextField
                      v-model="editUser.name"
                      label="Nama"
                    />
                  </div>
                  <div class="form-row">
                    <VSelect
                      v-model="editUser.role"
                      :items="roles"
                      label="Peranan"
                      multiple
                      clearable
                      @change="updateRoleSelection"
                    />
                  </div>
                  <div class="form-row">
                    <VTextField
                      v-model="editUser.email"
                      label="Emel"
                    />
                  </div>
                  <div class="form-row">
                    <VTextField
                      v-model="editUser.password"
                      label="Kata laluan"
                    />
                  </div>
                </VCardText>
                <VCardActions>
                  <VSpacer />
                  <VBtn
                    color="secondary"
                    @click="isEditDialogVisible = false"
                  >
                    Tutup
                  </VBtn>
                  <VBtn
                    color="success-darken-1"
                    @click="saveEdit"
                  >
                    Simpan
                  </VBtn>
                </VCardActions>
              </VCard>
            </VDialog>


            <VDialog
              v-model="isDeleteDialogVisible"
              max-width="400"
            >
              <VCard>
                <VCardText class="text-center">
                  <VIcon
                    size="64"
                    color="orange"
                  >
                    tabler-alert-octagon
                  </VIcon>
                  <div class="dialog-title">
                    <strong>Pasti?</strong>
                  </div>

                  <p>Data pengguna ini akan dibuang!</p>
                </VCardText>
                <VCardActions class="justify-center">
                  <VBtn
                    color="primary"
                    class="white--text"
                    @click="confirmDelete"
                  >
                    Ya, buang
                  </VBtn>
                  <VBtn
                    color="error"
                    class="white--text"
                    @click="isDeleteDialogVisible = false"
                  >
                    Batal
                  </VBtn>
                </VCardActions>
              </VCard>
            </VDialog>
          </VCol>
        </VRow>
      </div>
    </div>
  </AdminBackground>
  <PrimaryModule />
  <VDialog
    v-model="popup.visible"
    max-width="400"
  >
    <VCard>
      <VCardText class="text-center">
        <VIcon
          color="success"
          size="56"
        >
          mdi-check-circle
        </VIcon>
        <h3 class="mt-3">
          {{ popup.message }}
        </h3>
      </VCardText>
    </VCard>
  </VDialog>
</template>

<script setup>
import { useHttpService } from "@/httpService"
import { computed, onMounted, ref } from 'vue'

import axios from 'axios'

const loginApiUrl = import.meta.env.VITE_LOGIN_API_URL
const token = localStorage.getItem('token')

const axiosAuth = axios.create({
  baseURL: loginApiUrl,
  headers: {
    Authorization: `Bearer ${token}`,
  },
})

definePage({
  alias: '/pages/pages/inspektorat/ahli-pbt',
  meta: {
    layout: 'blank',
    public: true,
  },
})

const headers = [
  { title: 'Nama', key: 'name' },
  { title: 'email', key: 'email' },
  { title: 'Peranan', key: 'assignedTo', sortable: false },
  { title: 'Actions', key: 'actions', sortable: false },
]

const search = ref('')
const itemsPerPage = ref(10)
const page = ref(1)
const sortBy = ref()
const orderBy = ref()

const updateOptions = options => {
  sortBy.value = options.sortBy?.[0]?.key
  orderBy.value = options.sortBy?.[0]?.order
}


const isAddUserDialogVisible = ref(false)
const isEditDialogVisible = ref(false)
const isDeleteDialogVisible = ref(false)


const newUser = ref({
  name: '',
  role: [],
  email: '',
  password: '',
})

const editUser = ref({
  name: '',
  role: [],
  email: '',
  password: '',
})

const popup = ref({
  visible: false,
  message: '',
})

function showPopup(message) {
  popup.value.message = message
  popup.value.visible = true
  setTimeout(() => {
    popup.value.visible = false
  }, 3000) 
}

const roles = [
  'Manager',
  'Inspektorat',
  'Pembangunan',
  'Kesihatan Persekitaran',
  'Kejuruteraan Kesihatan Umum',
  'Kejuruteraan Awam',
  'Kawalan Pemajuan',
  'Kampung Baru',
  'Khidmat Pengurusan',
  'Pengurusan Maklumat',
]

const colors = {
  'manager': { color: 'primary', text: 'Manager' },
  'inspektorat': { color: 'info', text: 'Inspektorat' },
  'pembangunan': { color: 'success', text: 'Pembangunan' },
  'kesihatan persekitaran': { color: 'warning', text: 'Kesihatan Persekitaran' },
  'kejuruteraan kesihatan umum': { color: 'error', text: 'Kejuruteraan Kesihatan Umum' },
  'kejuruteraan awam': { color: 'secondary', text: 'Kejuruteraan Awam' },
  'kawalan pemajuan': { color: 'info-darken-1', text: 'Kawalan Pemajuan' },
  'kampung baru': { color: 'success-darken-1', text: 'Kampung Baru' },
  'khidmat pengurusan': { color: 'grey-600', text: 'Khidmat Pengurusan' },
  'pengurusan maklumat': { color: 'info', text: 'Pengurusan Maklumat' },
}


const { loading, error, httpDelete, httpGet, httpPost,
  numberWithCommas,
  formatToMillion, calculatePercentage } = useHttpService()

const responseData = ref(null)

async function loadDataFromApi() {
  try {
    const response = await axiosAuth.get('users')

    responseData.value = Array.isArray(response.data) ? response.data : []
  } catch (err) {
    console.error('loadDataFromApi failed:', err)
    responseData.value = []
  }
}

onMounted(() => {
  loadDataFromApi()
})

const filteredPermissions = computed(() => {
  if (!responseData.value) return []

  if (!search.value.trim()) {
    return responseData.value || []
  }

  return responseData.value.filter(user => {
    const nameMatch = user.name
      ?.toLowerCase()
      .includes(search.value.toLowerCase())

    const emailMatch = user.email
      ?.toLowerCase()
      .includes(search.value.toLowerCase())

    
    return nameMatch || emailMatch
  })
})


const permissions = computed(() => {
  const start = (page.value - 1) * itemsPerPage.value
  const end = start + itemsPerPage.value
  
  return filteredPermissions.value.slice(start, end)
})

const totalPermissions = computed(() => filteredPermissions.value.length)

async function addUser() {
  try {
    const payload = {
      name: newUser.value.name.trim(),
      email_address: newUser.value.email.trim(), 
      password: newUser.value.password.trim(),
      role: newUser.value.role, 
    }

    if (!payload.name || !payload.email_address || !payload.password || !payload.role.length) {
      throw new Error("All fields are required.")
    }
    const response = await axiosAuth.post('users', payload)
 
    responseData.value.push(response.data)


    newUser.value = { name: '', role: [], email: '', password: '' }
    isAddUserDialogVisible.value = false
    console.log('User added successfully:', response)
    showPopup('Pengguna berjaya ditambah!')
  } catch (err) {

    console.error('Failed to add user:', err.message, err.errors)
  }
}

function updateRoleSelection(newRoles) {
  // Ensure the roles array has unique entries
  editUser.value.role = [...new Set(newRoles)];
  console.log("Updated roles:", editUser.value.role);
}


const filteredRoles = ref([])

const showEditDialog = item => {
  editUser.value = {
    id: item.id,
    name: item.name,
    email: item.email,
    role: item.roles.map(role => role.name), 
  }

  filteredRoles.value = roles.filter(
    role => !editUser.value.role.includes(role),
  )

  isEditDialogVisible.value = true

  console.log("editUser set in showEditDialog:", editUser.value)
  console.log("Available roles for selection:", filteredRoles.value)
}


async function saveEdit() {
  try {
    const uniqueRoles = [...new Set(editUser.value.role)]

    const payload = {
      id: editUser.value.id,
      name: editUser.value.name,
      email_address: editUser.value.email,
      role: uniqueRoles,
    }

    // const response = await axiosAuth.put(`users/update/${editUser.value.id}`, payload)

    const response = await axiosAuth.put(`users/${editUser.value.id}`, payload)


    console.log('API Response:', response)

    const index = responseData.value.findIndex(user => user.id === editUser.value.id)
    if (index !== -1) {
      responseData.value[index] = response.data
    }

    isEditDialogVisible.value = false
    showPopup('Data pengguna berjaya diubah!')
  } catch (err) {
    console.error('Failed to edit user:', err)
    showPopup('Gagal mengubah data pengguna!')
  }
}


const showDeleteDialog = item => {
  editUser.value = { id: item.id, ...item } 
  isDeleteDialogVisible.value = true

  console.log("User to delete:", editUser.value)
}

async function confirmDelete() {
  try {
    if (!editUser.value.id) {
      throw new Error("User ID is not defined.")
    }

    const endpoint = `users/${editUser.value.id}`
    
    await axiosAuth.delete(endpoint)

    responseData.value = responseData.value.filter(user => user.id !== editUser.value.id)

    isDeleteDialogVisible.value = false
    showPopup("Pengguna berjaya dipadam!")
  } catch (err) {
    console.error("Failed to delete user:", err)
    showPopup("Gagal memadam pengguna!")
  }
}
</script>


<style scoped>
.content-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
  inline-size: 100%;
}

.image-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-block-end: 20px;
}

.pbt-image {
  block-size: auto;
  max-inline-size: 70%; /* Adjusted size */
}

.line-under-image {
  border-radius: 5px;
  background-color: white;
  block-size: 5px;
  inline-size: 70%; /* Match width to the image size */
  margin-block-start: 10px;
}

/* Gap between line and the map */
.map-gap {
  margin-block: 10px; /* Increase this for more gap */
}

h2 {
  display: block;
  color: #150069;
  font-size: 30px;
  font-weight: 600;
  font-weight: bold;
  margin-block-end: 20px;
  text-align: start;
}


.pbtpay-status {
  display: flex;
  flex-direction: column;
  padding: 20px;
  border-radius: 10px;
  background-color: rgba(255, 255, 255, 65%);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 20%);
  inline-size: 100%;
  margin-block-end: 50px;
  max-inline-size: 1200px;
}

.pbtpay-box {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-block-end: 30px;
}

.form-row {
  margin-bottom: 16px; 
}
</style>
